import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const ENV_NAME = environment.name;
const ENV_PROD = environment.production;
const API_URL = environment.apiUrl;
const API_OLD_URL = environment.apiOldUrl;
const JUPITER_URL = environment.jupiterUrl;
const COOKIE_DOMAIN = environment.cookieDomain;

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  env_name = ENV_NAME;
  env_prod = ENV_PROD;
  api_url = API_URL;
  api_old_url = API_OLD_URL;
  jupiter_url = JUPITER_URL;
  // Nova is this app itself, so its url is always just the current origin
  // rather than a per-environment hardcoded value.
  nova_url: string;
  cookieDomain = COOKIE_DOMAIN;

  constructor(public document: Document) {
    this.nova_url = this.document.location.origin;
  }
}
